import SubTitle from "../../components/SubTitle";
import ShopSubTitle from "../../components/shop/ShopSubTitle";

const IndexSection = ({ title, titleJP, subtitles, items, bottomText, bottomTextJP }) => {
  return (
    <div className="shop-list-section index-section">
      <div className="container shop-main-section">
            <div className="shop-title-view">
                {/* Section Header */}
                <SubTitle title={title} subTitle={titleJP} />
                <div className="shop-menu">
                    {items.map((item, key) => {
                        return (
                            <ShopSubTitle
                                key={key}
                                href={item.link}
                                title={item.title}
                                subTitle={item.titleJP}
                                textColor={item.textColor}
                                index={key + 1}
                            />
                        );
                    })}
                </div>
            </div>
            
            {/* Optional section-level bottom text */}
            {(bottomText || bottomTextJP) && (
                <div className="sub-title-view">
                    <p className="title-text font-amaticsc-bold">
                        {bottomText}
                    </p>
                    <p className="sub-title-text font-zenkurenaido">
                        {bottomTextJP}
                    </p>
                </div>
            )}
      </div>
    </div>  
  );
};

export default IndexSection;